import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography, Paper, Alert, Button } from '@mui/material';

const PublicCertificateViewer = () => {
  const { certId, token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

  useEffect(() => {
    if (!certId || !token) {
      setError('Invalid certificate link.');
      setLoading(false);
      return;
    }

    const apiPath = `/api/public/certificate/${certId}/${token}/pdf/`;
    let objectUrl = null;

    const fetchPdf = async () => {
      try {
        const response = await fetch(apiPath);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const blob = await response.blob();
        objectUrl = URL.createObjectURL(blob);
        setPdfUrl(objectUrl);
      } catch (err) {
        setError(err.message || 'Failed to load certificate.');
      } finally {
        setLoading(false);
      }
    };

    fetchPdf();
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [certId, token]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f5f5f5">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f5f5f5" p={3}>
        <Paper elevation={3} sx={{ p: 4, maxWidth: 600 }}>
          <Alert severity="error">
            <Typography variant="h6" gutterBottom>Certificate Unavailable</Typography>
            <Typography>{error}</Typography>
          </Alert>
        </Paper>
      </Box>
    );
  }

  if (isMobile && pdfUrl) {
    return (
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="100vh" gap={2}>
        <Typography variant="h6">Your certificate is ready.</Typography>
        <Button variant="contained" size="large" onClick={() => window.open(pdfUrl, '_blank')}>
          Open PDF
        </Button>
      </Box>
    );
  }

  return (
    <Box minHeight="100vh" bgcolor="#fff">
      {pdfUrl && (
        <iframe src={pdfUrl} title="Certificate" style={{ width: '100%', height: '100vh', border: 'none' }} />
      )}
    </Box>
  );
};

export default PublicCertificateViewer;
